import React from 'react';
import { Toolbar, SaveButton } from 'react-admin';

const CustomEditActions = props => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
);

export default CustomEditActions;